const LowCosts = () => {
  return (
    <svg
      className="low-costs-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M18.51 63.6834L21.0567 69.8267C24.9934 68.5167 31.4067 66.6667 33.3334 66.6667C36.1267 66.6667 38.2067 67.36 40.6134 68.16C43.1967 69.0234 46.1267 70 50 70C53.9234 70 60.26 66.93 61.49 66.3167L58.5067 60.3534C56.1034 61.5534 51.7367 63.3334 50 63.3334C47.2067 63.3334 45.1267 62.64 42.72 61.84C40.1367 60.9767 37.2067 60 33.3334 60C32.57 60 31.58 60.1234 30.4767 60.33C32.34 56.5 33.3334 51.87 33.3334 46.6667H43.3334V40H32.0867C31.9467 39.6434 31.8067 39.28 31.67 38.9434C30.81 36.84 30 34.85 30 30C30 25.4367 31.7367 20 40 20C47.4134 20 50.07 27.4234 50.1734 27.72L56.4934 25.61C56.3267 25.11 52.2634 13.3334 40 13.3334C27.71 13.3334 23.3334 21.9434 23.3334 30C23.3334 34.97 24.1134 37.8334 24.9267 40H16.6667V46.6667H26.6667C26.6667 54.89 23.6934 61.0934 18.51 63.6834Z"
        fill="white"
      />
    </svg>
  );
};

export default LowCosts;
